export const MARKUP_MARKER_TYPE = 0;
export const ATOM_MARKER_TYPE = 1;